import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useRef } from "react";
import { useHandleClickCTA } from "../workout/misc";
import { useModals } from "./container";

const Content = ({ launchProgramID, CTALabel = "Get The App" }) => {
  const { title, description, handleClose } = useModals();
  const { handleClickCta } = useHandleClickCTA(launchProgramID, CTALabel);
  const handleClick = () => {
    handleClose();
    setTimeout(() => handleClickCta(), 250);
  };

  return (
    <>
      <div>
        <div className="mx-auto flex items-center justify-center p-1">
          <img
            className="p-2"
            src="/assets/logo/white.svg"
            alt="Ladder Logo"
            width={632 * 0.2}
            height={104 * 0.2}
          />
        </div>
        <div className="mt-3 text-center sm:mt-5">
          <Dialog.Title
            as="h3"
            className="text-2xl uppercase leading-tight font-display font-medium text-white/90"
          >
            {title}
          </Dialog.Title>
          <div className="mt-4">
            <p className="text-gray-400">{description}</p>
          </div>
        </div>
      </div>
      <div className="mt-10">
        <button
          type="button"
          className="block mx-auto cta justify-center rounded-full border border-transparent shadow-sm px-8 py-2 bg-volt text-base font-medium text-black focus:outline-none focus:ring-2 sm:col-start-2"
          onClick={handleClick}
        >
          {CTALabel}
        </button>
      </div>
    </>
  );
};

export const AppLockedPrompt = (props) => {
  const { appLockedPromptOpen: isOpen, setAppLockedPromptOpen: setIsOpen } =
    useModals();
  const cancelButtonRef = useRef(null);

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        style={{ zIndex: 100 }}
        className="fixed inset-0 overflow-y-auto"
        initialFocus={cancelButtonRef}
        onClose={setIsOpen}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-white/50 backdrop-blur-sm transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="relative inline-block align-bottom bg-dark-slanted-gradient border border-space-200 rounded-xl px-4 pt-5 pb-6 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 sm:pb-12">
              <Content {...props} />
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
